import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as ToggleIcon } from '@assets/icons/order/toggle-details.svg';

import { toastError } from '@components/Toast';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import { generateOrderDashboardParams } from '@features/filter/static/filterUtil';
import OrderCancelStatusFilter from '@features/order-dashboard/component/OrderCancelStatusFIlter';
import OrderDashboardGroup from '@features/order-dashboard/component/OrderDashboardGroup';
import OrderPageSort from '@features/order-dashboard/component/OrderPageSort';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { downloadBlobFIle } from '@utils/Util';

const FilterTopHeader = ({
	filterType,
	showFilterButton = true,
	toggleFilter,
	toggleSummary,
	showSummary,
	totalItem = 0,
	isOrderDashboard = true
}) => {
	const [showColumns, setShowColumns] = useState(false);
	const orderDashboardStore = useSelector((store) => store.orderDashboardStore);
	const dispatch = useDispatch();
	const dropdownRef = useRef();
	const dropdownButtonRef = useRef();
	const filterFields = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		if (isOrderDashboard) {
			document.addEventListener('mousedown', handleOutsideClick);
			return () => {
				document.removeEventListener('mousedown', handleOutsideClick);
			};
		}
	}, []);

	const handleOutsideClick = (event) => {
		if (dropdownButtonRef && dropdownButtonRef.current.contains(event.target)) {
			return false;
		}
		if (dropdownRef && !dropdownRef.current.contains(event.target)) {
			setShowColumns(false);
		}
	};

	const toggleColumns = (name) => {
		dispatch({
			type: Types.TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN,
			payload: name
		});
	};

	const renderColumns = () => {
		return (
			<div className={showColumns ? 'dropdown-box' : 'dropdown-box d-none'} ref={dropdownRef}>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="PoDetails"
							name
							defaultValue
							onChange={() => toggleColumns('isPOColumnVisible')}
							checked={orderDashboardStore?.isPOColumnVisible}
						/>
						<label htmlFor="PoDetails">
							<span>PO details</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="priceColumn"
							name
							defaultValue
							onChange={() => toggleColumns('isPriceColumnVisible')}
							checked={orderDashboardStore?.isPriceColumnVisible}
						/>
						<label htmlFor="priceColumn">
							<span>Price</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="ScDetails"
							name
							onChange={() => toggleColumns('isSCColumnVisible')}
							checked={orderDashboardStore?.isSCColumnVisible}
							defaultValue
						/>
						<label htmlFor="ScDetails">
							<span>SC details</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="ETD"
							name
							defaultValue
							onChange={() => toggleColumns('isETDColumnVisible')}
							checked={orderDashboardStore?.isETDColumnVisible}
						/>
						<label htmlFor="ETD">
							<span>ETD</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="tnaStatusColumn"
							name
							defaultValue
							onChange={() => toggleColumns('isTnaStatusColumnVisible')}
							checked={orderDashboardStore?.isTnaStatusColumnVisible}
						/>
						<label htmlFor="tnaStatusColumn">
							<span>TNA Status</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="shipmentDetails"
							name
							onChange={() => toggleColumns('isSPColumnVisible')}
							checked={orderDashboardStore?.isSPColumnVisible}
							defaultValue
						/>
						<label htmlFor="shipmentDetails">
							<span>Shipment details</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox border-bottom pb-1">
					<div className="form-group">
						<input
							type="checkbox"
							id="fabricDetails"
							name
							onChange={() => toggleColumns('isFabricColumnVisible')}
							checked={orderDashboardStore?.isFabricColumnVisible}
							defaultValue
						/>
						<label htmlFor="fabricDetails">
							<span>Fabric</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox mt-1">
					<div className="form-group">
						<input
							type="checkbox"
							id="allTask"
							name
							onChange={() => toggleColumns('isAllColumnVisible')}
							checked={orderDashboardStore?.isAllColumnVisible}
							defaultValue
						/>
						<label htmlFor="allTask">
							<span>All task</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="critical"
							name
							onChange={() => toggleColumns('isCriticalColumnVisible')}
							checked={orderDashboardStore?.isCriticalColumnVisible}
							defaultValue
						/>
						<label htmlFor="critical">
							<span>Critical</span>
						</label>
					</div>
				</div>
				{/* {renderStages()} */}
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="production"
							name
							onChange={() => toggleColumns('isProductionColumnVisible')}
							checked={orderDashboardStore?.isProductionColumnVisible}
							defaultValue
						/>
						<label htmlFor="production">
							<span>Production</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="sample"
							name
							onChange={() => toggleColumns('isSampleColumnVisible')}
							checked={orderDashboardStore?.isSampleColumnVisible}
							defaultValue
						/>
						<label htmlFor="sample">
							<span>Sample</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="delivery"
							name
							onChange={() => toggleColumns('isDeliveryColumnVisible')}
							checked={orderDashboardStore?.isDeliveryColumnVisible}
							defaultValue
						/>
						<label htmlFor="delivery">
							<span>Delivery</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="inspection"
							name
							onChange={() => toggleColumns('isInspectionColumnVisible')}
							checked={orderDashboardStore?.isInspectionColumnVisible}
							defaultValue
						/>
						<label htmlFor="inspection">
							<span>Inspection</span>
						</label>
					</div>
				</div>
				<div className="custom-chekbox">
					<div className="form-group">
						<input
							type="checkbox"
							id="sweater"
							name
							onChange={() => toggleColumns('isSweaterColumnVisible')}
							checked={orderDashboardStore?.isSweaterColumnVisible}
							defaultValue
						/>
						<label htmlFor="sweater">
							<span>Sweater</span>
						</label>
					</div>
				</div>
			</div>
		);
	};

	const setReportColumns = (params) => {
		if (params.length > 0) params += '&';

		let uniqueObjArray = [
			...new Map(orderDashboardStore?.headings.map((item) => [item['stageConstants'], item])).values()
		];
		let stageConstantsList = [];
		for (let item of uniqueObjArray) {
			if (item.isColumnVisible) {
				stageConstantsList.push(item.stageConstants);
			}
		}

		params += `isAllTask=${orderDashboardStore.isAllColumnVisible}&isBrandAndTeam=${
			orderDashboardStore.isBrandColumnVisible
		}&isCritical=${orderDashboardStore.isCriticalColumnVisible}&isEtd=${
			orderDashboardStore.isETDColumnVisible
		}&isPoDetails=${orderDashboardStore.isPOColumnVisible}&isScDetails=${
			orderDashboardStore.isSCColumnVisible
		}&isPrice=${orderDashboardStore.isPriceColumnVisible}&isShipment=${orderDashboardStore.isSPColumnVisible}&isStyle=${
			orderDashboardStore.isStyleColumnVisible
		}&isShipment=${orderDashboardStore.isFabricColumnVisible}&isStyle=${
			orderDashboardStore.isFabricColumnVisible
		}&isTnaStatus=${orderDashboardStore.isTnaStatusColumnVisible}&isSweater=${
			orderDashboardStore.isSweaterColumnVisible
		}&stageConstantsList=${stageConstantsList.join(',')}`;

		return params;
	};

	const downloadReport = () => {
		dispatch(openLoader());
		let params = generateOrderDashboardParams(filterFields);

		ApiClient.GET_FILE_DATA('downloadOrderDashboardReports', `?${setReportColumns(params.slice(1))}`)
			.then((response) => {
				downloadBlobFIle(response);
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	return (
		<div className="top-header ">
			<div className="filter-container-top filter-container-top-v2 bg-gray">
				<div className="filters">
					{showFilterButton && (
						<div className="filter-toggle" onClick={toggleFilter}>
							<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
							<img
								src={`${process.env.PUBLIC_URL}/icons/filter-close.svg`}
								alt="filter"
								className="d-none"
							/>
							<span>Filter</span>
						</div>
					)}
					<span className="items-count semibold-14 gray_dark_02">
						{totalItem > 0 ? `${totalItem} items` : `${totalItem} item`}
					</span>
					{isOrderDashboard && (
						<span
							className="items-count semibold-14 gray_dark_02 cursor-pointer"
							onClick={toggleSummary}
						>
							<span className={showSummary ? 'enable-rotate' : 'disable-rotate'}>
								<ToggleIcon />
							</span>
						</span>
					)}
					<Chip />
				</div>
				{/*Filter Actions*/}

				<div className="filter-actions collections-filter-actions">
					<div className={'filter-actions collections-filter-actions'}>
						<Search placeholder={'SC, PO, style no, order title'} />
					</div>
					{!isOrderDashboard ? (
						<>
							{filterType === 'ORDER_DASHBOARD' && <OrderPageSort />}
							{filterType === 'CANCEL' && <OrderCancelStatusFilter />}
						</>
					) : (
						<>
							<div className="select-component order-column-filter">
								<div
									className="click-box click mb-1"
									ref={dropdownButtonRef}
									onClick={() => setShowColumns((prev) => !prev)}
								>
									<p className="regular-14 ">Column</p>
									<img src={`${process.env.PUBLIC_URL}/images/chevron_down.svg`} alt="" />
								</div>
								{renderColumns()}
							</div>
							<OrderDashboardGroup />

							<div className="add-new-design">
								<button className="button text size32 px-0" onClick={downloadReport}>
									<img
										src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
										alt="add"
									/>
									<span className="ml-1">Report</span>
								</button>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default FilterTopHeader;
